import * as Yup from 'yup';

const Validation = Yup.object({
    title: Yup.string().required("Title is Required"),
});

export default Validation;
